export default __webpack_public_path__ + "static/media/tablet.413d6236.svg";